export const validateEmail = (email: string): boolean => {
  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  return emailRegex.test(email);
};

export const validatePhone = (phone: string): boolean => {
  const phoneRegex = /^\+?[\d\s-()]{10,}$/;
  return phoneRegex.test(phone);
};

export const validateRequired = (value: string): boolean => {
  return value.trim().length > 0;
};

export const validateZipCode = (zip: string): boolean => {
  const zipRegex = /^\d{5}(-\d{4})?$/;
  return zipRegex.test(zip);
};

export const getValidationError = (field: string, value: string): string => {
  switch (field) {
    case "email":
      return validateEmail(value) ? "" : "Please enter a valid email address";
    case "phone":
      return validatePhone(value) ? "" : "Please enter a valid phone number";
    case "zip":
      return validateZipCode(value) ? "" : "Please enter a valid ZIP code";
    case "required":
      return validateRequired(value) ? "" : "This field is required";
    default:
      return "";
  }
};
